import { Component, Input, OnInit } from '@angular/core'

export type HeaderInstallBannerType = 'large' | 'small'

@Component({
  selector: 'header-install-banner',
  templateUrl: './header-install-banner.component.html',
  styleUrls: ['./header-install-banner.component.scss'],
})
export class HeaderInstallBannerComponent implements OnInit {
  constructor() {}

  @Input() bannerStyle: HeaderInstallBannerType = 'small'
  @Input() appLinkPath: string | undefined
  @Input() isBackgroundColorDark = false
  hideAppInstallBanner = false

  ngOnInit() {}

  onClickClose(): void {
    this.hideAppInstallBanner = true
  }
  onClickOpenApp(): void {}
}
